const actions = {
    GET_DEVICES: 'devices/GET_DEVICES',
    SET_DEVICES: 'devices/SET_DEVICES',

    GET_DEVICE: 'devices/GET_DEVICE',
    SET_DEVICE: 'devices/SET_DEVICE',

    SET_INITIAL: 'devices/SET_INITIAL',
};

export default actions;